<script lang="ts">
  import { getCommonTranslations } from '@athena-lib/commonTranslationsContext';
  import Link from '@athena-lib/Link/Link.svelte';
  import ArrowDropDown from '@athena-lib/Icons/ArrowDropDown.svelte';
  import Button from '@athena-lib/Button/Button/Button.svelte';
  import type { SiteSelectorProps } from './types';

  let { sites }: SiteSelectorProps = $props();
  let value = $state('');
  let isOpen = $state(false);
  let popover = $state<HTMLElement | undefined>(undefined);
  let container = $state<HTMLElement | undefined>(undefined);
  const translations = getCommonTranslations();

  $effect(() => {
    value = window.location.origin + '/';
  });

  $effect(() => {
    if (popover && isOpen) {
      popover.setAttribute('open', 'true');
    } else {
      popover?.removeAttribute('open');
    }
  });

  // Single effect that manages the click outside listener
  $effect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (container && !container.contains(event.target as Node)) {
        isOpen = false;
      }
    }

    // Always add the listener
    document.addEventListener('click', handleClickOutside);

    // Always return cleanup function
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  });

  // Alternative: Handle it directly in the click handler
  function toggleDropdown(event: MouseEvent) {
    event.stopPropagation();
    isOpen = !isOpen;
  }
</script>

<div
  bind:this={container}
  class="relative flex w-full justify-between rounded-md border border border-st-white py-2 pl-3 pr-2 ring-offset-1 has-[:focus]:ring has-[:focus]:ring-st-blue-500 md:border-st-white lg:border-st-white"
>
  <Button
    onClick={toggleDropdown}
    class="w-full appearance-none text-left outline-none"
    unstyled={true}
  >
    <div class="flex flex-col">
      <span class="text-xs text-st-gray-400">{translations.siteSelector}</span>
      <span class="text-sm">{value}</span>
    </div>
  </Button>
  <div
    bind:this={popover}
    class:hidden={!isOpen}
    class="absolute bottom-full left-0 z-50 mb-2 w-full min-w-max rounded-md border border-st-gray-200 bg-st-black shadow-lg"
  >
    <div class="py-2">
      {#each sites as site}
        <Link
          href={site.url}
          class="block px-4 py-2 text-sm hover:bg-st-gray-100 hover:text-gray-900"
        >
          {site.name}
        </Link>
      {/each}
    </div>
  </div>
  <ArrowDropDown sizeClass="w-5 aspect-square" />
</div>
